import { render, staticRenderFns } from "./Stripe2.vue?vue&type=template&id=2b39e1fb&scoped=true"
import script from "./Stripe2.vue?vue&type=script&lang=js"
export * from "./Stripe2.vue?vue&type=script&lang=js"
import style0 from "./Stripe2.vue?vue&type=style&index=0&id=2b39e1fb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b39e1fb",
  null
  
)

export default component.exports